import type { Theme } from './types';

export type FormFieldStyleVariant = 'default' | 'auth' | 'filter' | 'settings';

export type FormFieldBackgroundColor = string;

export const resolveFormFieldBackgroundColor = (
  _fieldStyle: FormFieldStyleVariant,
  inputBackgroundColor?: FormFieldBackgroundColor,
): FormFieldBackgroundColor => {
  if (inputBackgroundColor) {
    return inputBackgroundColor;
  }

  return 'var(--control-surface)';
};

type TypographyValue = string | number | ((theme: Theme) => string | number);

type FormFieldTypography = {
  fontSize: TypographyValue;
  lineHeight: TypographyValue;
};

const resolveSubtitle1FontSize = (theme: Theme): string | number =>
  theme.typography.subtitle1.fontSize ?? theme.typography.body1.fontSize ?? '1rem';

const resolveSubtitle1LineHeight = (theme: Theme): string | number =>
  theme.typography.subtitle1.lineHeight ?? theme.typography.body1.lineHeight ?? 1.5;

export const formFieldTypographySx: FormFieldTypography = {
  fontSize: resolveSubtitle1FontSize,
  lineHeight: resolveSubtitle1LineHeight,
};

export const formFieldPlaceholderTypographySx: FormFieldTypography & {
  color: 'text.secondary';
  opacity: 1;
} = {
  ...formFieldTypographySx,
  color: 'text.secondary',
  opacity: 1,
};

export const resolveFormFieldInputTextColor = (
  fieldStyle: FormFieldStyleVariant,
): 'common.white' | undefined => (fieldStyle === 'filter' ? 'common.white' : undefined);

export const resolveFormFieldPlaceholderTypographySx = (
  fieldStyle: FormFieldStyleVariant,
): FormFieldTypography & { color: 'text.secondary' | 'common.white'; opacity: 1 } =>
  fieldStyle === 'filter'
    ? {
        ...formFieldTypographySx,
        color: 'common.white',
        opacity: 1,
      }
    : formFieldPlaceholderTypographySx;
